// extracted by mini-css-extract-plugin
export var close = "PaymentModal_close__Jn2DJ";
export var content = "PaymentModal_content__WwKhs";
export var pmContainer = "PaymentModal_pmContainer__oUevB";
export var pmSubtitle = "PaymentModal_pmSubtitle__qX5NJ";
export var pmTitle = "PaymentModal_pmTitle__qewfh";